import React, { memo } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import styles from './style'

const MainContainer = memo(({ classes, children }) => (
	<main className={classes.mainContent}>
		<div className={classes.container}>
			<div className={classes.wrapper}>{children}</div>
		</div>
	</main>
))

export default withStyles(styles, { name: 'MuiStaticLayout' })(MainContainer)
